import { ZoneNameDistribution } from "@/types/zone-name.type";
import { chartOptionDefault } from "@/helper/chart/constants/chart-option-default.const";
import { ChartOption } from "@/helper/chart/types/chart-option.type";
import { buildDistributionChart } from "@/helper/chart/build-distribution-chart.util";
import { getPaymentZoneColor } from "@/helper/colors/payment-zones";

export const getPaymentZonesChart = (
  paymentZones: ZoneNameDistribution[],
  options: ChartOption = chartOptionDefault,
) => {
  return buildDistributionChart({
    items: paymentZones,
    options,
    getLabel: (zone) => zone.zone_name,
    getColor: (zone) => getPaymentZoneColor(zone.zone_name),
  });
};
